import { FORM_TYPE, OPTION_LIST_TYPES } from "../custom-define-type";
import {
    SHIFT_JOB_CSV_OPTIONS, DEFAULT_SHIFT_JOB_CSV_OPTIONS,
    DEFAULT_SHIFT_JOB_CANCELLATION_REASON_LIST,
    DEFAULT_CANDIDATE_AVAILABLE_JOBS_TABLE_FIELDS,
    DEFAULT_PLACEMENT_JOB_STATUSES,
    DEFAULT_CANDIDATE_ACCEPT_JOB_CONFIRM_MESSAGE,
    DEFAULT_CANDIDATE_ACCEPT_JOB_BUTTON_TEXT,
    DEFAULT_MY_JOBS_TABLE_FIELDS,
    DEFAULT_CANDIDATE_JOB_REPORT_PROBLEM_BUTTON_TEXT,
    DEFAULT_REPORT_PROBLEM_UPLOAD_FILE_LABEL,
    DEFAULT_REPORT_PROBLEM_UPLOAD_FILE_DESCRIPTION,
    DEFAULT_REPORT_PROBLEM_NOTE_LABEL,
    DEFAULT_PLACEMENT_JOB_DETAIL_VIEW_FIELDS,
    BOOKING_RESULT_DEFAULT_FIELDS,
    DEFAULT_STATUS_CANDIDATE_MARK_JOB_COMPLTED,
    DEFAULT_BUTTON_TEXT_CANDIDATE_MARK_JOB_COMPLTED,
    DEFAULT_DISCLAIMER_TEXT
} from "../default-values";
import { CANDIDATE_TAGS_CANDIDATE_TABLE_SETTINGS } from "./user-dashboard";

import { CUSTOMIZE_PRICE_INFO_TEXT_OPTIONS } from "../options";

export const TIME_SHEET_TABLE_FIELDS_SETTINGS = [
    {
        key: "REVERSE_DEFAULT_DATE_SORT_ORDER_SHIFT_JOB_CALENDAR_TABLE_VIEW",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'advance_setting.reverse_default_date_sort_order_shift_table_view',
    },
    {
        key: "SELECT_FIELDS_TABLE_VIEW",
        model: "advance_setting.time_sheet_table_columns",
        type: FORM_TYPE.BUILDER_FIELD_SELECTOR,
        optionListModel: [],
        predefinedOptionList: []
    },
]

export const SHIFT_JOB_PAST_DATE_RANGE_FILTER_SETTINGS = [
    {
        key: "SHIFT_JOB_PAST_DATE_RANGE_FILTER",
        model: "advance_setting.load_shift_jobs_number_of_past_days",
        type: FORM_TYPE.TEXTBOX,
    },
]

export const SHIFT_JOB_FUTURE_DATE_RANGE_FILTER_SETTINGS = [
    {
        key: "SHIFT_JOB_FUTURE_DATE_RANGE_FILTER",
        model: "advance_setting.load_shift_jobs_number_of_future_days",
        type: FORM_TYPE.TEXTBOX,
    },
]

export const CANDIDATE_MY_JOBS_PAST_DATE_RANGE_FILTER_SETTINGS = [
    {
        key: "CANDIDATE_MY_JOBS_PAST_DATE_RANGE_FILTER",
        model: "advance_setting.load_my_job_of_past_days",
        type: FORM_TYPE.TEXTBOX,
        default: 14,
    },
]

export const CANDIDATE_MY_JOBS_FUTURE_DATE_RANGE_FILTER_SETTINGS = [
    {
        key: "CANDIDATE_MY_JOBS_FUTURE_DATE_RANGE_FILTER",
        model: "advance_setting.load_my_job_of_future_days",
        type: FORM_TYPE.TEXTBOX,
        default: 28,
    },
]

export const CANDIDATE_MY_SCHEDULE_PAST_DATE_RANGE_FILTER_SETTINGS = [
    {
        key: "CANDIDATE_MY_SCHEDULE_PAST_DATE_RANGE_FILTER",
        model: "advance_setting.load_my_schedule_of_past_days",
        type: FORM_TYPE.TEXTBOX,
        default: 14,
    },
]

export const CANDIDATE_MY_SCHEDULE_FUTURE_DATE_RANGE_FILTER_SETTINGS = [
    {
        key: "CANDIDATE_MY_SCHEDULE_FUTURE_DATE_RANGE_FILTER",
        model: "advance_setting.load_my_schedule_of_future_days",
        type: FORM_TYPE.TEXTBOX,
        default: 28,
    },
]

export const JOB_CSV_EXPORT_FIELD_SETTINGS = [
    {
        key: "JOB_CSV_EXPORT_FIELD",
        model: "advance_setting.shift_job_csv_fields",
        type: FORM_TYPE.BUILDER_FIELD_SELECTOR,
        default: DEFAULT_SHIFT_JOB_CSV_OPTIONS,
        optionList: SHIFT_JOB_CSV_OPTIONS,
        predefinedOptionList: []
    }
]

export const FULFILLMENT_EXCLUDE_STATUSES_SETTINGS = [
    {
        key: "FULFILLMENT_EXCLUDE_STATUSES",
        model: "advance_setting.fulfillment_exclude_statuses",
        type: FORM_TYPE.MULTI_SELECT,
        isMulti: true,
        default: ['Cancelled',],
        optionListModel: 'shift_job_statuses',
        optionLabel: "status",
        optionModel: "status",
        canEmpty: true
    }
]

export const PLACEMENT_JOB_TYPES_FIELD_SETTINGS = [
    {
        key: "PLACEMENT_JOB_TYPES_FIELD",
        type: FORM_TYPE.LIST_TEXTFIELD_INPUT,
        model: 'public_advance_setting.placement_job_types',
    }
]

export const PLACEMENT_JOB_STATUSES_FIELD_SETTINGS = [
    {
        key: "PLACEMENT_JOB_STATUSES_FIELD",
        type: FORM_TYPE.LIST_TEXTFIELD_INPUT,
        model: 'placement_job_statuses',
        hasInitElement: false,
        default: DEFAULT_PLACEMENT_JOB_STATUSES
    }
]

export const SHIFT_JOB_STATUSES_FIELD_SETTINGS = [
    {
        key: "SHIFT_JOB_STATUSES_FIELD",
        type: FORM_TYPE.STATUS_COLOR_INPUT,
        fieldLabel: "Status",
        model: 'shift_job_statuses',
    },
    {
        key: "REASON_FOR_CANCELLATION_SHIFT_JOB",
        type: FORM_TYPE.LIST_TEXTFIELD_INPUT,
        model: 'public_advance_setting.shift_job_cancellation_reason_list',
        hasInitElement: false,
        default: DEFAULT_SHIFT_JOB_CANCELLATION_REASON_LIST
    },
    {
        key: "SHIFT_JOB_STATUSES_DO_NOT_BLOCK_AVAILABILTIY",
        model: "public_advance_setting.list_shift_job_statuses_cancelled",
        type: FORM_TYPE.MULTI_SELECT,
        isMulti: true,
        default: ['Cancelled',],
        optionListModel: 'shift_job_statuses',
        optionLabel: "status",
        optionModel: "status",
        canEmpty: true
    }
]

export const CANDIDATE_AVAILABLE_JOBS_TABLE_FIELDS_SETTINGS = [
    {
        key: "SELECT_FIELDS_TABLE_VIEW",
        model: "advance_setting.candidate_available_jobs_table_columns",
        type: FORM_TYPE.BUILDER_FIELD_SELECTOR,
        default: DEFAULT_CANDIDATE_AVAILABLE_JOBS_TABLE_FIELDS,
    },
]

export const DEFAULT_FILTER_CANDIDATE_STATUS_SHIFT_JOB_BROADCAST_SETTINGS = [
    {
        key: "DEFAULT_FILTER_CANDIDATE_STATUS_SHIFT_JOB_BROADCAST",
        type: FORM_TYPE.MULTI_SELECT,
        isMulti: true,
        hasClearButton: true,
        closeOnSelect: false,
        model: 'advance_setting.default_candidate_statuses_shift_job_broadcast',
        optionListModel: 'candidate_statuses',
        default: []
    }
]

export const DEFAULT_FILTER_CANDIDATE_STATUS_PLACEMENT_JOB_BROADCAST_SETTINGS = [
    {
        key: "DEFAULT_FILTER_CANDIDATE_STATUS_PLACEMENT_JOB_BROADCAST",
        type: FORM_TYPE.MULTI_SELECT,
        isMulti: true,
        hasClearButton: true,
        closeOnSelect: false,
        model: 'placement_job_broadcast_statuses',
        optionListModel: 'candidate_statuses',
        default: []
    }
]

export const DEFAULT_FILTER_CANDIDATE_HIDE_STATUS_SHIFT_JOB_BROADCAST_SETTINGS = [
    {
        key: "DEFAULT_FILTER_CANDIDATE_HIDE_STATUS_SHIFT_JOB_BROADCAST",
        type: FORM_TYPE.MULTI_SELECT,
        isMulti: true,
        hasClearButton: true,
        closeOnSelect: false,
        model: 'advance_setting.default_candidate_hide_statuses_shift_job_broadcast',
        optionListModel: 'candidate_statuses',
        default: []
    }
]

export const DEFAULT_FILTER_CANDIDATE_HIDE_STATUS_PLACEMENT_JOB_BROADCAST_SETTINGS = [
    {
        key: "DEFAULT_FILTER_CANDIDATE_HIDE_STATUS_PLACEMENT_JOB_BROADCAST",
        type: FORM_TYPE.MULTI_SELECT,
        isMulti: true,
        hasClearButton: true,
        closeOnSelect: false,
        model: 'advance_setting.default_candidate_hide_statuses_placement_job_broadcast',
        optionListModel: 'candidate_statuses',
        default: []
    }
]

export const DEFAULT_FILTER_CANDIDATE_TYPES_SHIFT_JOB_BROADCAST_SETTINGS = [
    {
        key: "DEFAULT_FILTER_CANDIDATE_TYPES_SHIFT_JOB_BROADCAST",
        type: FORM_TYPE.MULTI_SELECT,
        isMulti: true,
        hasClearButton: true,
        closeOnSelect: false,
        model: 'advance_setting.default_candidate_types_shift_job_broadcast',
        optionListModel: 'candidate_types',
        default: []
    }
]

export const FILTER_LOCATION_SHIFT_JOB_BROADCAST_SETTINGS = [
    {
        key: "INITIAL_FILTER_LOCATION_BY_CLIENT_LOCATION",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'advance_setting.initial_filter_location_by_client_location',
        default: false,
    },
]

export const DEFAULT_FILTER_CANDIDATE_TAGS_SHIFT_JOB_BROADCAST_SETTINGS = [
    {
        key: "DEFAULT_FILTER_CANDIDATE_TAGS_SHIFT_JOB_BROADCAST",
        type: FORM_TYPE.MULTI_SELECT,
        isMulti: true,
        hasClearButton: true,
        closeOnSelect: false,
        model: 'advance_setting.default_candidate_tags_shift_job_broadcast',
        optionListModel: 'candidate_tags',
        default: []
    },
    ...CANDIDATE_TAGS_CANDIDATE_TABLE_SETTINGS
]

export const CANDIDATE_APPLICATION_STATUS_COLOR_SETTINGS = [
    {
        key: "CANDIDATE_EACH_STATUS_APPLICATION_COLOR",
        type: FORM_TYPE.STATUS_COLOR_INPUT,
        fieldLabel: "Status",
        optionListModel: 'advance_setting.candidate_client_relationship_status',
        hasInitElement: false,
        model: "public_advance_setting.candidate_table_application_status_color",
    },
]

export const CANCELLING_REASON_SHIFT_JOB_SETTINGS = [
    {
        key: "DO_NOT_ASK_FOR_REASON_CANCELLING_SHIFT_JOB",
        model: "public_advance_setting.do_not_ask_reason_client_cancels_shift_job",
        type: FORM_TYPE.CHECKBOX_ITEM
    },
    {
        key: "INCLUDE_CANCELLING_REASON_CANDIDATE_EMAIL_SHIFT_JOB",
        model: "public_advance_setting.include_booking_cancel_reason_candidate_email",
        type: FORM_TYPE.CHECKBOX_ITEM,
        default: false
    },
    {
        key: "CUSTOM_CONFIRM_TEXT_CLIENT_CANCEL_SHIFT_JOB",
        type: FORM_TYPE.TEXT_EDITOR,
        model: "advance_setting.custom_text_canceling_shift_job",
    }
]
export const PLACEMENT_JOB_BROADCAST_SETTINGS = [
    {
        key: "DISABLE_PLACEMENT_JOB_DEFAULT_DISTANCE_SEARCH_ON_BROADCAST",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'advance_setting.disable_placement_job_default_distance_search',
        default: false,
    },
]
export const HIDE_CANDIDATES_SHIFT_JOB_BROADCAST_SETTINGS = [
    {
        key: "HIDE_CANDIDATES_SHIFT_JOB_BROADCAST_ALREADY_BOOKED",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'advance_setting.check_hide_booked_candidates_broadcast',
        default: true,
    },
    {
        key: "HIDE_CANDIDATES_SHIFT_JOB_BROADCAST_TIME_OFF",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'advance_setting.check_hide_timeoff_candidates_broadcast',
        default: true,
    },
    {
        key: "HIDE_CANDIDATES_SHIFT_JOB_BROADCAST_NOT_AVAILABLE",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'advance_setting.check_hide_unavailable_candidates_broadcast',
        default: true,
    },
    {
        key: "HIDE_CANDIDATES_SHIFT_JOB_BROADCAST_NO_MATCHING_TAG",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'advance_setting.hide_candidates_no_matching_tag_broadcast',
        default: false,
    },
    {
        key: "HIDE_CANDIDATES_SHIFT_JOB_BROADCAST_DO_NOT_MATCH_LIST",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'advance_setting.hide_candidates_do_not_match_list',
        default: true,
    },
    {
        key: "DISABLE_SHIFT_JOB_DEFAULT_DISTANCE_SEARCH_ON_BROADCAST",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'advance_setting.disable_shift_job_default_distance_search',
        default: false,
    },
]

export const DEFAULT_JOB_STATUS_SHIFT_JOB_CALENDAR_SETTINGS = [
    {
        key: "DEFAULT_JOB_STATUS_SHIFT_JOB_CALENDAR",
        type: FORM_TYPE.MULTI_SELECT,
        model: 'advance_setting.default_filter_job_statuses_shift_job_calendar',
        isMulti: true,
        hasClearButton: true,
        closeOnSelect: false,
    }
]

export const JOB_PAGE_SETTING = [
    {
        key: "CUSTOM_CONFIRM_TEXT_ACCEPT_JOB",
        type: FORM_TYPE.TEXT_EDITOR,
        model: "public_advance_setting.custom_confirm_text_accept_job",
        default: DEFAULT_CANDIDATE_ACCEPT_JOB_CONFIRM_MESSAGE
    },
    {
        key: "CANDIDATE_CAN_MARK_CLIENT_AS_FAV",
        model: "public_advance_setting.candidate_can_mark_client_favorite",
        type: FORM_TYPE.CHECKBOX_ITEM,
        default: false
    },
    {
        key: "CANDIDATE_CAN_MARK_CLIENT_AS_DO_NOT_WANT_AGAIN",
        model: "public_advance_setting.candidate_can_mark_client_do_not_want_again",
        type: FORM_TYPE.CHECKBOX_ITEM,
        default: false
    },
    {
        key: "SELECT_ZOOM_LEVEL_OF_JOB_MAP",
        model: "public_advance_setting.zoom_level_of_job_map",
        isIntegerField: true,
        default: 13
    },
    {
        key: "SELECT_FIELDS_OF_CLIENT_SHIFT_JOB_PROFILE",
        model: "public_advance_setting.client_shift_job_profile",
        type: FORM_TYPE.BUILDER_FIELD_SELECTOR,
        default: [],
    },
    {
        key: "SELECT_FIELDS_OF_CLIENT_SHIFT_JOB_PROFILE_TO_ASSIGNEE",
        model: "public_advance_setting.client_shift_job_profile_assignee",
        type: FORM_TYPE.BUILDER_FIELD_SELECTOR,
        default: [],
    },
    {
        key: "SHOW_CLIENT_PROFILE_ON_JOB_LISTING",
        model: "show_client_profile_on_job_listings",
        type: FORM_TYPE.CHECKBOX_ITEM,
        default: false
    },
    {
        key: "SHOW_CLIENT_PROFILE_ON_JOB_LISTING_TO_ASSIGNEE_ONLY",
        model: "public_advance_setting.visible_to_assign_candidates",
        type: FORM_TYPE.CHECKBOX_ITEM,
        default: false,
        showIf: "show_client_profile_on_job_listings",
        showIfValue: "Yes"
    },
    {
        key: "CANDIDATE_STATUSES_CAN_VIEW_CLIENT_PROFILE",
        model: "public_advance_setting.candidate_statuses_can_view_client_profile",
        type: FORM_TYPE.MULTI_SELECT,
        isMulti: true,
        optionListModel: 'candidate_statuses',
        showIf: "show_client_profile_on_job_listings",
        showIfValue: "Yes",
        showIfSecondary: "public_advance_setting.visible_to_assign_candidates",
        showIfValueSecondary: "No",
        showIfEmptySecondary: true
    },
    {
        key: "CANDIDATE_TYPES_CAN_VIEW_CLIENT_PROFILE",
        model: "public_advance_setting.candidate_types_can_view_client_profile",
        type: FORM_TYPE.MULTI_SELECT,
        optionListModel: "candidate_types",
        isMulti: true,
        showIf: "show_client_profile_on_job_listings",
        showIfValue: "Yes",
        showIfSecondary: "public_advance_setting.visible_to_assign_candidates",
        showIfValueSecondary: "No",
        showIfEmptySecondary: true
    },
]

export const CANDIDATE_MY_JOBS_TABLE_SETTINGS = [
    {
        key: "SELECT_FIELDS_MY_JOBS_TABLE",
        model: "advance_setting.my_jobs_table_columns",
        type: FORM_TYPE.BUILDER_FIELD_SELECTOR,
        default: DEFAULT_MY_JOBS_TABLE_FIELDS,
    },
    {
        key: "CANDIDATE_CUSTOM_CLOCKOUT_MESSAGE",
        model: "advance_setting.candidate_custom_clockout_message",
        type: FORM_TYPE.TEXTAREA,
        default: ""
    },
    {
        key: "HAS_REPORT_PROBLEM_BUTTON",
        model: "advance_setting.has_report_problem_button",
        type: FORM_TYPE.CHECKBOX_ITEM,
        default: false
    },
    {
        key: "REPORT_PROBLEM_BUTTON_TEXT",
        model: "advance_setting.report_problem_button_text",
        type: FORM_TYPE.TEXTBOX,
        default: DEFAULT_CANDIDATE_JOB_REPORT_PROBLEM_BUTTON_TEXT,
        showIf: "advance_setting.has_report_problem_button",
        showIfValue: "Yes"
    },
    {
        key: "REPORT_PROBLEM_UPLOAD_FILE_LABEL",
        model: "advance_setting.report_problem_upload_file_label",
        type: FORM_TYPE.TEXTBOX,
        default: DEFAULT_REPORT_PROBLEM_UPLOAD_FILE_LABEL,
        showIf: "advance_setting.has_report_problem_button",
        showIfValue: "Yes"
    },
    {
        key: "REPORT_PROBLEM_UPLOAD_FILE_DESCRIPTION",
        model: "advance_setting.report_problem_upload_file_description",
        type: FORM_TYPE.TEXTAREA,
        default: DEFAULT_REPORT_PROBLEM_UPLOAD_FILE_DESCRIPTION,
        showIf: "advance_setting.has_report_problem_button",
        showIfValue: "Yes"
    },
    {
        key: "REPORT_PROBLEM_NOTE_LABEL",
        model: "advance_setting.report_problem_note_label",
        type: FORM_TYPE.TEXTBOX,
        default: DEFAULT_REPORT_PROBLEM_NOTE_LABEL,
        showIf: "advance_setting.has_report_problem_button",
        showIfValue: "Yes"
    },
    {
        key: "REPORT_PROBLEM_NOTIFICATION_EMAILS",
        type: FORM_TYPE.LIST_TEXTFIELD_INPUT,
        model: 'advance_setting.report_problem_notification_emails',
        hasInitElement: false,
        showIf: "advance_setting.has_report_problem_button",
        showIfValue: "Yes"
    },
    {
        key: "REPORT_PROBLEM_NEW_JOB_STATUS",
        optionListModel: "shift_job_statuses",
        optionLabel: "status",
        optionModel: "status",
        type: FORM_TYPE.MULTI_SELECT,
        isMulti: false,
        model: "advance_setting.report_problem_new_job_status",
        showIf: "advance_setting.has_report_problem_button",
        showIfValue: "Yes"
    },
    {
        key: "CANDIDATE_CAN_MARK_JOB_AS_COMPLETED",
        model: "advance_setting.candidate_can_mark_job_as_completed",
        type: FORM_TYPE.CHECKBOX_ITEM,
        default: false
    },
    {
        key: "MARK_JOB_COMPLETED_BUTTON_TEXT",
        model: "advance_setting.mark_job_completed_button_text",
        type: FORM_TYPE.TEXTBOX,
        default: DEFAULT_BUTTON_TEXT_CANDIDATE_MARK_JOB_COMPLTED,
        showIf: "advance_setting.candidate_can_mark_job_as_completed",
        showIfValue: "Yes"
    },
    {
        key: "STATUS_JOB_CANDIDATE_MARK_COMPLETED",
        optionListModel: "shift_job_statuses",
        optionLabel: "status",
        optionModel: "status",
        type: FORM_TYPE.MULTI_SELECT,
        isMulti: false,
        model: "advance_setting.job_status_after_candidate_mark_job_completed",
        showIf: "advance_setting.candidate_can_mark_job_as_completed",
        showIfValue: "Yes",
        default: DEFAULT_STATUS_CANDIDATE_MARK_JOB_COMPLTED
    },
    {
        key: "HAS_CLOCK_IN_CLOCK_OUT_BUTTON",
        model: "advance_setting.hide_clock_in_out",
        type: FORM_TYPE.CHECKBOX_ITEM,
        default: false,
        showIf: "advance_setting.candidate_can_mark_job_as_completed",
        showIfValue: "No",
        showIfEmpty: true
    },
    {
        key: "MANUALLY_CLOCK_IN_CLOCK_OUT_JOBS",
        model: "manual_clocking",
        type: FORM_TYPE.CHECKBOX_ITEM,
        default: false,
        showIf: "advance_setting.candidate_can_mark_job_as_completed",
        showIfValue: "No",
        showIfEmpty: true
    },
    {
        key: "GET_USER_LOCATIONS_WHEN_CLOCK_IN_OUT",
        model: "advance_setting.get_user_location_when_clock_in_out",
        type: FORM_TYPE.CHECKBOX_ITEM,
        default: false,
        showIf: "advance_setting.candidate_can_mark_job_as_completed",
        showIfValue: "No",
        showIfEmpty: true
    },
    {
        key: "MINUTES_INTERVAL_CANDIDATE_CLOCK_IN_CLOCK_OUT",
        model: "advance_setting.minute_interval_clock_in_out",
        type: FORM_TYPE.MULTI_SELECT,
        default: 15,
        hasClearButton: true,
        closeOnSelect: true,
        isMulti: false,
        optionLabel: "label",
        optionModel: "model",
        showIf: "advance_setting.candidate_can_mark_job_as_completed",
        showIfValue: "No",
        showIfEmpty: true
    },
    {
        key: "HIDE_MILEAGE_QUESTION_CANDIDATE_CLOCK_OUT_SHIFT_JOB",
        model: "advance_setting.hide_mileage_question",
        type: FORM_TYPE.CHECKBOX_ITEM,
        default: false,
        showIf: "advance_setting.candidate_can_mark_job_as_completed",
        showIfValue: "No",
        showIfEmpty: true
    },
    {
        key: "CHARGE_TRANSFER_INCLUDE_MILEAGE",
        model: "advance_setting.charge_transfer_include_mileage",
        type: FORM_TYPE.CHECKBOX_ITEM,
        default: false,
        showIf: "advance_setting.hide_mileage_question",
        showIfValue: "No",
        showIfEmpty: true
    },
    {
        key: "CHARGE_TRANSFER_PRICE_PER_MILE",
        model: "advance_setting.charge_transfer_price_per_mile",
        type: FORM_TYPE.TEXTBOX,
        default: "0.625",
        showIf: "advance_setting.charge_transfer_include_mileage",
        showIfValue: "Yes"
    },
    {
        key: "HIDE_REIMBURSEMENT_QUESTION_CANDIDATE_CLOCK_OUT_SHIFT_JOB",
        model: "advance_setting.hide_reimbursement_question",
        type: FORM_TYPE.CHECKBOX_ITEM,
        default: false,
        showIf: "advance_setting.candidate_can_mark_job_as_completed",
        showIfValue: "No",
        showIfEmpty: true
    },
    {
        key: "CHARGE_TRANSFER_INCLUDE_REIMBURSEMENT",
        model: "advance_setting.charge_transfer_include_reimbersement",
        type: FORM_TYPE.CHECKBOX_ITEM,
        default: false,
        showIf: "advance_setting.hide_reimbursement_question",
        showIfValue: "No",
        showIfEmpty: true
    },
    {
        key: "CANDIDATE_ABLE_CREATE_JOBS_TO_CLOCK_IN_OUT",
        model: "advance_setting.candidates_can_create_jobs",
        type: FORM_TYPE.CHECKBOX_ITEM,
        default: false
    },
    {
        key: "CLIENT_CAN_CONFIRM_CLOCK_IN_OUT_CANDIDATE_PHONE",
        model: "advance_setting.client_confirm_clock_in_out",
        type: FORM_TYPE.CHECKBOX_ITEM,
        default: false,
        showIf: "advance_setting.candidate_can_mark_job_as_completed",
        showIfValue: "No",
        showIfEmpty: true
    },
    {
        key: "STATUS_JOB_CLIENT_CONFIRM_CLOCK_IN_OUT_TIME",
        optionListModel: "shift_job_statuses",
        optionLabel: "status",
        optionModel: "status",
        type: FORM_TYPE.MULTI_SELECT,
        isMulti: false,
        model: "advance_setting.job_status_after_client_confirm_clock_in_out",
        showIf: "advance_setting.client_confirm_clock_in_out",
    },
    {
        key: "STATUS_JOB_CLIENT_DISAPPROVE_CLOCK_IN_OUT_TIME",
        optionListModel: "shift_job_statuses",
        optionLabel: "status",
        optionModel: "status",
        type: FORM_TYPE.MULTI_SELECT,
        default: "Client Disapproved",
        isMulti: false,
        model: "advance_setting.job_status_after_client_disapprove_clock_in_out",
        showIf: "advance_setting.client_confirm_clock_in_out",
    },
    {
        key: "NOTIFY_CANDIDATE_SHIFT_JOB_STARTING_IN_X_HOURS",
        type: FORM_TYPE.MULTI_SELECT,
        optionList: [0, 1, 2, 4, 6, 12, 18, 24, 48, 72],
        closeOnSelect: false,
        isMulti: true,
        hasClearButton: true,
        model: "advance_setting.hours_notify_filler",
        itemPerRow: 2,
        infoLinkId: "SET_NOTIFICATION_TO_CANDIDATE_FOR_SHIFT_JOB"
    },
    {
        key: "METHOD_NOTIFY_CANDIDATE_SHIFT_JOB_STARTING_IN_X_HOURS",
        type: FORM_TYPE.MULTI_SELECT,
        optionList: ['Email', 'SMS'],
        closeOnSelect: false,
        isMulti: true,
        model: "advance_setting.methods_notify_filler",
        default: ["Email"],
        itemPerRow: 2,
    },
    {
        key: "NOTIFY_CANDIDATE_FOR_CLOCK_IN_MINUTES",
        type: FORM_TYPE.MULTI_SELECT,
        optionList: [0, 5, 10, 15, 30, 60, 120, 180, 360, 1440],
        closeOnSelect: false,
        isMulti: true,
        hasClearButton: true,
        model: "advance_setting.minutes_notify_clockin",
        itemPerRow: 2,
    },
    {
        key: "NOTIFY_CANDIDATE_FOR_CLOCK_OUT_MINUTES",
        type: FORM_TYPE.MULTI_SELECT,
        optionList: [0, 5, 10, 15, 30, 60, 120, 180, 360, 1440],
        closeOnSelect: false,
        isMulti: true,
        hasClearButton: true,
        model: "advance_setting.minutes_notify_clockout",
        itemPerRow: 2,
    },
    {
        key: "METHOD_NOTIFY_CLOCK_IN_OUT",
        type: FORM_TYPE.MULTI_SELECT,
        optionList: ['Email', 'SMS'],
        closeOnSelect: false,
        isMulti: true,
        model: "advance_setting.methods_notify_clock_inout",
        default: ["Email"],
        itemPerRow: 1,
    },
    {
        key: "RECORD_BREAK_ITEMS_DURING_SHIFTS",
        model: "advance_setting.can_add_breaks",
        type: FORM_TYPE.CHECKBOX_ITEM,
        default: false
    },
    {
        key: "CANDIDATE_CAN_SUBMIT_SHIFT_JOB_REPORT",
        model: "advance_setting.candidate_can_submit_shift_job_report",
        type: FORM_TYPE.CHECKBOX_ITEM,
        default: false
    },
    {
        key: "SHIFT_JOB_REPORT_ADMIN_ONLY",
        model: "advance_setting.shift_job_report_admin_only",
        type: FORM_TYPE.CHECKBOX_ITEM,
        default: false,
        showIf: "advance_setting.candidate_can_submit_shift_job_report",
        showIfValue: "Yes"
    },
    {
        key: "SUBMIT_SHIFT_JOB_REPORT_MANDATORY_BEFORE_CLOCKOUT",
        model: "advance_setting.shift_job_report_mandatory",
        type: FORM_TYPE.CHECKBOX_ITEM,
        default: false,
        showIf: "advance_setting.candidate_can_submit_shift_job_report",
        showIfValue: "Yes"
    },
    {
        key: "CUSTOMIZE_SUBMIT_REPORT_BUTTON_LABEL",
        model: "advance_setting.customize_submit_report_button_label",
        type: FORM_TYPE.TEXTBOX,
        default: 'Submit Report',
        showIf: "advance_setting.candidate_can_submit_shift_job_report",
        showIfValue: "Yes"
    },
    {
        key: "ADMIN_EMAIL_NOTIFICATION_SHIFT_JOB_REPORT",
        model: "advance_setting.admin_ids_notification_shift_job_report",
        type: FORM_TYPE.MULTI_SELECT,
        isMulti: true,
        optionListType: OPTION_LIST_TYPES.ADMIN_LIST,
        optionLabel: "email",
        optionModel: "id",
        showIf: "advance_setting.candidate_can_submit_shift_job_report",
        showIfValue: "Yes"
    },
    {
        key: "CANDIDATE_NOT_ALLOW_REVIEW",
        model: "public_advance_setting.candidate_not_allow_review",
        type: FORM_TYPE.CHECKBOX_ITEM,
        default: false
    },
]

export const CLIENT_BOOKING_SETTINGS = [
    {
        key: "CLIENT_HAS_REPORT_PROBLEM_BUTTON",
        model: "advance_setting.has_report_problem_button_for_client",
        type: FORM_TYPE.CHECKBOX_ITEM,
        default: false
    },
    {
        key: "REPORT_PROBLEM_BUTTON_TEXT",
        model: "advance_setting.client_report_problem_button_text",
        type: FORM_TYPE.TEXTBOX,
        default: DEFAULT_CANDIDATE_JOB_REPORT_PROBLEM_BUTTON_TEXT,
        showIf: "advance_setting.has_report_problem_button_for_client",
        showIfValue: "Yes"
    },
    {
        key: "REPORT_PROBLEM_UPLOAD_FILE_LABEL",
        model: "advance_setting.client_report_problem_upload_file_label",
        type: FORM_TYPE.TEXTBOX,
        default: DEFAULT_REPORT_PROBLEM_UPLOAD_FILE_LABEL,
        showIf: "advance_setting.has_report_problem_button_for_client",
        showIfValue: "Yes"
    },
    {
        key: "REPORT_PROBLEM_UPLOAD_FILE_DESCRIPTION",
        model: "advance_setting.client_report_problem_upload_file_description",
        type: FORM_TYPE.TEXTAREA,
        default: DEFAULT_REPORT_PROBLEM_UPLOAD_FILE_DESCRIPTION,
        showIf: "advance_setting.has_report_problem_button_for_client",
        showIfValue: "Yes"
    },
    {
        key: "REPORT_PROBLEM_NOTE_LABEL",
        model: "advance_setting.client_report_problem_note_label",
        type: FORM_TYPE.TEXTBOX,
        default: DEFAULT_REPORT_PROBLEM_NOTE_LABEL,
        showIf: "advance_setting.has_report_problem_button_for_client",
        showIfValue: "Yes"
    },
    {
        key: "CLIENT_REPORT_PROBLEM_NOTIFICATION_EMAILS",
        type: FORM_TYPE.LIST_TEXTFIELD_INPUT,
        model: 'advance_setting.client_report_problem_notification_emails',
        hasInitElement: false,
        showIf: "advance_setting.has_report_problem_button_for_client",
        showIfValue: "Yes"
    },
    {
        key: "CLIENT_REPORT_PROBLEM_NEW_JOB_STATUS",
        optionListModel: "shift_job_statuses",
        optionLabel: "status",
        optionModel: "status",
        type: FORM_TYPE.MULTI_SELECT,
        isMulti: false,
        model: "advance_setting.client_report_problem_new_job_status",
        showIf: "advance_setting.has_report_problem_button_for_client",
        showIfValue: "Yes"
    },
]

export const QUICK_SEARCH_FIELDS_SHIFT_JOB_CALENDAR_SETTINGS = [
    {
        key: "QUICK_SEARCH_FIELDS_SHIFT_JOB_CALENDAR",
        model: "advance_setting.shift_job_calendar_search_fields",
        type: FORM_TYPE.BUILDER_FIELD_SELECTOR,
    },
    {
        key: "STATUS_HIDDEN_PAST_DATE_SHIFT_JOB_CALENDAR",
        model: "advance_setting.status_hidden_past_date_shift_job_calendar",
        type: FORM_TYPE.MULTI_SELECT,
        isMulti: true,
        default: [],
        optionListModel: 'shift_job_statuses',
        optionLabel: "status",
        optionModel: "status",
        canEmpty: true
    }
]

export const SEND_CONFIRMATION_EMAIL_BULK_ASSIGNING_SHIFT_JOB_SETTINGS = [
    {
        key: "SEND_EMAIL_TO_CANDIDATE_BULK_ASSIGNED_SHIFT_JOB",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'advance_setting.send_notification_to_candidate_on_bulk_assign_job',
        default: true,
    },
    {
        key: "SEND_EMAIL_TO_CLIENT_BULK_ASSIGNED_SHIFT_JOB",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'advance_setting.send_notification_to_client_on_bulk_assign_job',
        default: true,
    },
    {
        key: "SEND_SMS_TO_CANDIDATE_BULK_ASSIGNED_SHIFT_JOB",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'advance_setting.send_sms_notification_to_candidate_on_bulk_assign_job',
        default: false,
    },
    {
        key: "SEND_SMS_TO_CLIENT_BULK_ASSIGNED_SHIFT_JOB",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'advance_setting.send_sms_notification_to_client_on_bulk_assign_job',
        default: false,
    }
];

export const SEND_CONFIRMATION_EMAIL_ASSIGNING_SHIFT_JOB_SETTINGS = [
    {
        key: "SEND_EMAIL_TO_CANDIDATE_CANDIDATE_ASSIGNED_SHIFT_JOB",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'advance_setting.send_candidate_assign_confirmation_email_shift_job',
        default: true,
    },
    {
        key: "SEND_EMAIL_TO_CLIENT_CANDIDATE_ASSIGNED_SHIFT_JOB",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'advance_setting.send_client_assign_confirmation_email_shift_job',
        default: true,
    },
    {
        key: "SEND_SMS_TO_CANDIDATE_CANDIDATE_ASSIGNED_SHIFT_JOB",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'advance_setting.send_candidate_assign_confirmation_sms_shift_job',
        default: false,
    },
    {
        key: "SEND_SMS_TO_CLIENT_CANDIDATE_ASSIGNED_SHIFT_JOB",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'advance_setting.send_client_assign_confirmation_sms_shift_job',
        default: false,
    },
    {
        key: "SELECT_DEFAULT_CANDIDATE_STATUSES_APPEAR_ASSIGNING_CANDIDATE",
        type: FORM_TYPE.MULTI_SELECT,
        model: "advance_setting.default_candidate_statuses_appear_assigning_candidate",
        optionListModel: "candidate_statuses",
        closeOnSelect: false,
        isMulti: true,
        hasClearButton: true,
    },
    {
        key: "SELECT_DEFAULT_CANDIDATE_TYPES_APPEAR_ASSIGNING_CANDIDATE",
        type: FORM_TYPE.MULTI_SELECT,
        model: "advance_setting.default_candidate_types_appear_assigning_candidate",
        optionListModel: "candidate_types",
        closeOnSelect: false,
        isMulti: true,
        hasClearButton: true,
    },
    {
        key: "DO_NOT_WARN_ABOUT_CANDIDATE_GENERAL_AVAILABILITY",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'public_advance_setting.do_not_warn_about_candidate_availability',
        default: false,
    },
]

export const SHIFT_JOB_CALENDAR_FIELDS_SETTINGS = [
    {
        key: "SELECT_SHIFT_JOB_CALENDAR_FIELDS",
        model: "advance_setting.shift_job_calendar_fields",
        type: FORM_TYPE.BUILDER_FIELD_SELECTOR,
        default: [],
    },
]

export const SHIFT_JOB_CALENDAR_FIELDS_JOB_RESULT_INFO_SETTINGS = [
    {
        key: "SHIFT_JOB_CALENDAR_FIELDS_JOB_RESULT_INFO",
        model: "advance_setting.shift_job_calendar_result_fields",
        type: FORM_TYPE.BUILDER_FIELD_SELECTOR,
        default: BOOKING_RESULT_DEFAULT_FIELDS,
        predefinedOptionList: BOOKING_RESULT_DEFAULT_FIELDS
    },
]

export const PLACEMENT_JOBS_SETTINGS = [
    {
        key: "BROADCAST_STATUSES_PLACEMENT_JOBS",
        type: FORM_TYPE.MULTI_SELECT,
        model: 'placement_job_broadcast_statuses',
        optionListModel: "candidate_statuses",
        isMulti: true,
        searchable: true,
        closeOnSelect: true,
    },
    {
        key: "HIDE_DISTANCE_FROM_JOB_CANDIDATE_VIEW_PLACEMENT_JOBS",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'public_advance_setting.hide_distance_viewing_placement_job',
        default: false,
    },
    {
        key: "SHOW_NOT_INTERESTED_PLACEMENT_JOBS",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'public_advance_setting.show_placement_not_interested_button',
        default: true,
    },
    {
        key: "SHOW_MIGHT_BE_INTERESTED_PLACEMENT_JOBS",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'public_advance_setting.show_placement_maybe_interested_button',
        default: true,
    },
    {
        key: "NOTIFICATION_CLIENT_EXPRESS_INTEREST_CANDIDATE_PLACEMENT_JOBS",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'public_advance_setting.notify_client_when_interest_placement',
        default: false,
    },
    {
        key: "CANDIDATE_SEE_PLACEMENT_JOBS_OUTSIDE_LOCATION",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'public_advance_setting.can_see_placement_job_outside_location',
        default: true,
    },
    {
        key: "CANDIDATES_ACCEPT_JOB_WHEN_JOB_IS_BROADCASTED",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'public_advance_setting.candidates_accept_job_when_job_is_broadcasted',
        default: false,
    },
    {
        key: "JOB_FULL_WIDTH_BAR_STYLE_MODE",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'public_advance_setting.job_board_full_width_bar_mode',
        default: false,
    },
    {
        key: "SHOW_JOB_IMAGE_IN_FULL_WIDTH_BAR_STYLE_MODE",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'public_advance_setting.show_image_job_board_full_width_bar_mode',
        default: false,
        showIf: "public_advance_setting.job_board_full_width_bar_mode",
    },
    {
        key: "SHOW_HIRED_BADGE_ON_JOB_BOARD",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: "advance_setting.show_hired_badge_on_job_board",
        default: false,
        showIf: "public_advance_setting.job_board_full_width_bar_mode",
    },
    {
        key: "SHOW_MAP_WITH_LOCATIONS_ON_JOB_BOARD",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: "public_advance_setting.show_map_job_board",
        default: false,
    },
    {
        key: "JOB_BOARD_LONG_TERM_PLACEMENT_JOBS_HEADING",
        type: FORM_TYPE.TEXTBOX,
        model: 'placement_job_board_heading',
    },
    {
        key: "AVAILABLE_JOB_WITHIN_MILE_RADIUS_PLACEMENT_JOBS",
        type: FORM_TYPE.TEXTBOX,
        model: 'public_advance_setting.placement_job_distance_to_show_on_job_board',
    },
    {
        key: "SELECT_FIELDS_PLACEMENT_JOBS_DETAIL_VIEW",
        type: FORM_TYPE.BUILDER_FIELD_SELECTOR,
        model: 'public_advance_setting.job_board_detail_view_fields',
        optionList: [],
        default: DEFAULT_PLACEMENT_JOB_DETAIL_VIEW_FIELDS
    },
    {
        key: "CANDIDATE_STATUSES_SEE_PLACEMENT_JOBS",
        type: FORM_TYPE.MULTI_SELECT,
        model: 'advance_setting.placement_job_viewing_statuses',
        optionListModel: "candidate_statuses",
        isMulti: true,
        searchable: true,
        closeOnSelect: true,
    },
    {
        key: "CANDIDATE_TYPES_SEE_PLACEMENT_JOBS",
        type: FORM_TYPE.MULTI_SELECT,
        model: 'advance_setting.placement_job_viewing_types',
        optionListModel: "candidate_types",
        isMulti: true,
        searchable: true,
        closeOnSelect: true,
    }
]


export const CANDIDATE_VISIBILITY_REQUEST_SHIFT_JOBS_SETTINGS = [
    {
        key: "CANDIDATE_STATUSES_SEE_SHIFT_JOBS",
        type: FORM_TYPE.MULTI_SELECT,
        model: 'advance_setting.shift_job_viewing_statuses',
        optionListModel: "candidate_statuses",
        isMulti: true,
        searchable: true,
        closeOnSelect: true,
    },
    {
        key: "CANDIDATE_TAGS_SEE_SHIFT_JOBS",
        type: FORM_TYPE.MULTI_SELECT,
        model: 'advance_setting.shift_job_viewing_tags',
        optionListModel: "candidate_tags",
        isMulti: true,
        searchable: true,
        closeOnSelect: true,
    },
    {
        key: "CANDIDATE_TYPES_SEE_SHIFT_JOBS",
        type: FORM_TYPE.MULTI_SELECT,
        model: 'advance_setting.shift_job_viewing_types',
        optionListModel: "candidate_types",
        isMulti: true,
        searchable: true,
        closeOnSelect: true,
    },
    {
        key: "ONLY_ALLOW_CANDIDATE_TO_SEE_MATCHING_CATEGORY",
        model: "public_advance_setting.candidate_see_matching_category",
        type: FORM_TYPE.CHECKBOX_ITEM,
        default: false
    },
    {
        key: "CANDIDATE_STATUSES_REQUEST_WORK_SHIFT_JOBS",
        type: FORM_TYPE.MULTI_SELECT,
        model: 'shift_job_application_statuses',
        optionListModel: "candidate_statuses",
        isMulti: true,
        searchable: true,
        closeOnSelect: true,
    },
    {
        key: "CANDIDATE_TYPES_REQUEST_WORK_SHIFT_JOBS",
        type: FORM_TYPE.MULTI_SELECT,
        model: 'advance_setting.shift_job_application_types',
        optionListModel: "candidate_types",
        isMulti: true,
        searchable: true,
        closeOnSelect: true,
        hasClearButton: true,
    },
    {
        key: "CANDIDATE_SELF_ASSIGN_THEMSELVES_SHIFT_JOBS",
        model: "candidates_can_accept_shift_jobs",
        type: FORM_TYPE.CHECKBOX_ITEM,
        default: false
    },
    {
        key: "ONLY_ALLOW_CANDIDATE_TO_ACCEPT_MATCHING_CATEGORY",
        model: "public_advance_setting.candidate_accept_matching_category",
        showIf: "candidates_can_accept_shift_jobs",
        type: FORM_TYPE.CHECKBOX_ITEM,
        default: false
    },
    {
        key: "SHOW_MAP_WITH_LOCATIONS_ON_JOB_BOARD_SHIFT_JOB",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: "public_advance_setting.show_map_shift_job_board",
        default: false,
    },
    {
        key: "CANDIDATE_STATUSES_ACCEPT_SHIFT_JOBS",
        type: FORM_TYPE.MULTI_SELECT,
        model: 'shift_job_accept_statuses',
        optionListModel: "candidate_statuses",
        isMulti: true,
        searchable: true,
        closeOnSelect: true,
        hasClearButton: true,
        showIf: "candidates_can_accept_shift_jobs",
    },
    {
        key: "CUSTOM_CONFIRM_TEXT_ACCEPT_JOB",
        type: FORM_TYPE.TEXT_EDITOR,
        model: "public_advance_setting.custom_confirm_text_accept_job",
        default: DEFAULT_CANDIDATE_ACCEPT_JOB_CONFIRM_MESSAGE,
        showIf: "candidates_can_accept_shift_jobs",
    },
    {
        key: "CUSTOM_CONFIRM_TEXT_ACCEPT_JOB_BUTTON",
        type: FORM_TYPE.TEXTBOX,
        model: "public_advance_setting.custom_confirm_text_accept_job_button",
        default: DEFAULT_CANDIDATE_ACCEPT_JOB_BUTTON_TEXT,
        showIf: "candidates_can_accept_shift_jobs",
    },
    {
        key: "DEFAULT_VIEW_AVAILABLE_SHIFT_JOB_CALENDAR",
        type: FORM_TYPE.MULTI_SELECT,
        model: 'advance_setting.default_view_available_jobs_calendar',
        optionList: ['Week', '2 Weeks', 'Month', 'Year'],
        default: "Week",
        isMulti: false,
        searchable: false,
        closeOnSelect: true,
    },
    {
        key: "CUSTOM_TEXT_MESSAGE_SHIFT_JOB_ACCEPTED",
        type: FORM_TYPE.TEXT_EDITOR,
        model: "public_advance_setting.custom_text_shift_job_accepted",
    }
]

export const ADD_EDIT_BOOKING_DIALOG_SETTINGS = [
    {
        key: "DO_NOT_AUTO_POPULATE_ADDRESS",
        model: "public_advance_setting.do_not_auto_populate_address",
        type: FORM_TYPE.CHECKBOX_ITEM,
    },
    {
        key: "SELECT_MINUTES_INTERVAL_BOOKING_TIME",
        type: FORM_TYPE.MULTI_SELECT,
        model: "public_advance_setting.custom_minute_interval_booking_time",
        optionList: [1, 5, 10, 15, 30],
        closeOnSelect: true,
        isMulti: false,
        default: 15,
    },
    {
        key: "SELECT_MINUTES_INTERVAL_SHIFT_JOB_CALENDAR",
        type: FORM_TYPE.MULTI_SELECT,
        model: "advance_setting.booking_minutes_interval",
        optionList: [1, 5, 10, 15, 30],
        closeOnSelect: true,
        isMulti: false,
        default: 15,
    },
]

export const CANDIDATE_TAGS_SCHEDULER_VIEW_SETTINGS = [
    {
        key: "CANDIDATE_TAGS_MATCHING_OPTIONS_SCHEDULER_VIEW",
        model: "public_advance_setting.candiate_tags_matching_options_scheduler_view",
        type: FORM_TYPE.RADIO,
        default: 'All Of',
        optionList: ['All Of', 'Any Of', 'None Of']
    }
]

export const PUBLIC_JOB_START_DATE_SETTING = [
    {
        key: "PUBLIC_JOB_START_DATE_LABEL",
        model: "public_advance_setting.public_job_start_date_label",
        type: FORM_TYPE.TEXTBOX,
        default: "Start Date"
    },
]

export const PUBLIC_JOB_END_DATE_SETTING = [
    {
        key: "PUBLIC_JOB_END_DATE_LABEL",
        model: "public_advance_setting.public_job_end_date_label",
        type: FORM_TYPE.TEXTBOX,
        default: "End Date"
    },
]

export const PUBLIC_JOB_START_TIME_SETTING = [
    {
        key: "PUBLIC_JOB_START_TIME_LABEL",
        model: "public_advance_setting.public_job_start_time_label",
        type: FORM_TYPE.TEXTBOX,
        default: "Start Time"
    },
]

export const PUBLIC_JOB_END_TIME_SETTING = [
    {
        key: "PUBLIC_JOB_END_TIME_LABEL",
        model: "public_advance_setting.public_job_end_time_label",
        type: FORM_TYPE.TEXTBOX,
        default: "End Time"
    },
]

export const SCHEDULER_VIEW_DEFAULT_FILTERS_SETTINGS = [
    {
        key: "JOB_STATUSES_TO_HIDE_FROM_SCHEDULER_VIEW",
        type: FORM_TYPE.MULTI_SELECT,
        model: 'advance_setting.job_statuses_to_hide_scheduler_view',
        default: ['Assigned'],
        isMulti: true,
        closeOnSelect: false,
        hasClearButton: true,
    },
    {
        key: "DEFAULT_FILTER_CANDIDATE_TYPES_SCHEDULER_VIEW",
        type: FORM_TYPE.MULTI_SELECT,
        model: 'advance_setting.filter_candidate_types_scheduler_view',
        default: [],
        isMulti: true,
        closeOnSelect: false,
        hasClearButton: true,
        optionListModel: 'candidate_types',
    },
    {
        key: "DEFAULT_FILTER_CANDIDATE_STATUSES_SCHEDULER_VIEW",
        type: FORM_TYPE.MULTI_SELECT,
        model: 'advance_setting.filter_candidate_statuses_scheduler_view',
        default: [],
        isMulti: true,
        closeOnSelect: false,
        hasClearButton: true,
        optionListModel: 'candidate_statuses',
    },
    {
        key: "DEFAULT_FILTER_CANDIDATE_TAGS_SCHEDULER_VIEW",
        type: FORM_TYPE.MULTI_SELECT,
        model: 'advance_setting.filter_candidate_tags_scheduler_view',
        default: [],
        isMulti: true,
        closeOnSelect: false,
        hasClearButton: true,
        optionListModel: 'candidate_tags',
    },
    {
        key: "SHIFT_JOB_STATUS_AFTER_DRAG_DROP_TO_ASSIGN",
        model: "advance_setting.shift_job_status_after_drag_drop_to_assign",
        type: FORM_TYPE.MULTI_SELECT,
        isMulti: false,
        default: 'Assigned',
        optionListModel: 'shift_job_statuses',
        optionLabel: "status",
        optionModel: "status",
        canEmpty: true
    }
]

export const TIMESHEET_SUMMARY_SETTINGS = [
    {
        key: "USE_BOOKED_TIME_IF_NO_CLOCKED_TIME",
        model: "advance_setting.use_booked_time_if_no_clocked_time",
        type: FORM_TYPE.CHECKBOX_ITEM,
    },
]

export const DISCLAIMER_TEXT_ADDING_BOOKING_SETTING = [
    {
        key: "DISCLAIMER_TEXT_ADDING_BOOKING",
        type: FORM_TYPE.TEXT_EDITOR,
        model: "public_advance_setting.disclaimer_text_booking_section",
        default: DEFAULT_DISCLAIMER_TEXT
    }
]

export const SHIFT_JOB_BROADCAST_CANDIDATE_TABLE_FIELDS_SETTING = [
    {
        key: "SHIFT_JOB_BROADCAST_CANDIDATE_TABLE_FIELDS",
        model: "advance_setting.shift_job_broadcast_candidate_table_fields",
        type: FORM_TYPE.BUILDER_FIELD_SELECTOR,
        predefinedOptionList: [],
    },
]

export const PLACEMENT_JOB_BROADCAST_CANDIDATE_TABLE_FIELDS_SETTING = [
    {
        key: "PLACEMENT_JOB_BROADCAST_CANDIDATE_TABLE_FIELDS",
        model: "advance_setting.placement_job_broadcast_candidate_table_fields",
        type: FORM_TYPE.BUILDER_FIELD_SELECTOR,
        predefinedOptionList: [],
    },
]

export const TIME_SHEET_JOB_DIALOG_SETTINGS = [
    {
        key: "HIDE_SHIFT_JOB_DUPLICATE_BUTTON",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'advance_setting.hide_shift_job_duplicate_button',
    },
    {
        key: "HIDE_SHIFT_JOB_UPDATE_MANAGER_SECTION",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'advance_setting.hide_shift_job_update_manager',
    },
    {
        key: "HIDE_SHIFT_JOB_NOTES_SECTION",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'advance_setting.hide_shift_job_notes',
    },
]

export const SHIFT_JOB_CALENDAR_HIDE_UNAVAILABLE_CANDIDATES = [
    {
        key: "SHIFT_JOB_CALENDAR_HIDE_UNAVAILABLE_CANDIDATES",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: "advance_setting.admin_default_hide_unavailable_candidates",
    }
]

export const DEFAULT_FILTER_CLIENT_TYPES_SHIFT_JOB_CALENDAR_SETTINGS = [
    {
        key: "DEFAULT_FILTER_CLIENT_TYPES_SHIFT_JOB_CALENDAR",
        type: FORM_TYPE.MULTI_SELECT,
        isMulti: true,
        hasClearButton: true,
        closeOnSelect: false,
        model: 'advance_setting.filter_client_types_shift_job_calendar',
        optionListModel: 'employer_types',
        default: []
    }
]

export const DEFAULT_FILTER_CLIENT_STATUSES_SHIFT_JOB_CALENDAR_SETTINGS = [
    {
        key: "DEFAULT_FILTER_CLIENT_STATUSES_SHIFT_JOB_CALENDAR",
        type: FORM_TYPE.MULTI_SELECT,
        isMulti: true,
        hasClearButton: true,
        closeOnSelect: false,
        model: 'advance_setting.filter_client_statuses_shift_job_calendar',
        optionListModel: 'employer_statuses',
        default: []
    }
]

export const UNASSIGN_CANDIDATE_SETTINGS = [{
    key: "SEND_EMAIL_NOTIFICATION_WHEN_UNASSIGN_CANDIDATE",
    type: FORM_TYPE.CHECKBOX_ITEM,
    model: 'advance_setting.send_email_to_candidate_on_unassign',
    default: true,
}]


// WEBPACK FOOTER //
// ./src/constants/agency-settings/job-settings.js